import type { PropsWithChildren } from 'react';

type ChoiceGroupProps = {
  label: string;
  labelId?: string;
  className?: string;
};

export const ChoiceGroup = ({ label, labelId, className, children }: PropsWithChildren<ChoiceGroupProps>) => {
  return (
    <fieldset className={className}>
      <legend id={labelId} className="tds-input-label tds-legend mb-50">{label}</legend>
      {children}
    </fieldset>
  );
};
